import {
  AsianReportViewTypes,
  AsianReportViewTypes as ViewTypes,
  AsianStatementTabTypes as TabTypes,
  OpenBetsTypes,
} from "app/utils/const";
import { isEmpty } from "lodash";
import { defineMessages } from "react-intl";
export class OpenBetsHelper {
  static getBackMessageContent(
    props: Record<string, any>,
    isDetailedView: any
  ): any {
    let backMessage = "events-dashboard-back";

    if (props.reportType === OpenBetsTypes.OPENBETS) {
      if (isDetailedView && props.previousView === ViewTypes.LEAGUE) {
        backMessage = "asian-open-bets-back-league";
      } else if (isDetailedView && props.previousView === ViewTypes.MATCH) {
        backMessage = "asian-open-bets-back-match";
      }
    } else if (props.reportType === OpenBetsTypes.STATEMENT) {
      if (isDetailedView && props.previousView === ViewTypes.LEAGUE) {
        backMessage = "asian-statement-back-league";
      } else if (isDetailedView && props.previousView === ViewTypes.MATCH) {
        backMessage = "asian-statement-back-match";
      } else if (props.previousView === ViewTypes.SUMMARY) {
        if (props.statementTab === TabTypes.ALL) {
          backMessage = "asian-statement-all-back-summary";
        } else if (props.statementTab === TabTypes.FUNDING) {
          backMessage = "asian-statement-funding-back-summary";
        } else if (props.statementTab === TabTypes.BETTING) {
          backMessage = "asian-statement-betting-back-summary";
        }
      }
      if (props.currentView === AsianReportViewTypes.EXCHANGE_BETTING_BET) {
        backMessage = "statement-back-exchange";
      }
    }
    return backMessage;
  }

  static returnAsianOpenBetsTranslations() {
    const I18n = defineMessages({
      search: {
        id: "asian-open-bets-filter",
      },
      normal: {
        id: "asian-open-bets-normal",
      },
      league: {
        id: "asian-open-bets-league",
      },
      match: {
        id: "asian-open-bets-match",
      },
      page: {
        id: "asian-open-bets-page",
      },
    });
    return I18n;
  }

  static formatScores({ scores, showHomePlayerAsFirst }) {
    if (showHomePlayerAsFirst) {
      return !isEmpty(scores) && scores.length === 2 && scores[0] && scores[1]
        ? scores[0].score + " - " + scores[1].score
        : null;
    } else {
      return !isEmpty(scores) && scores.length === 2 && scores[0] && scores[1]
        ? scores[1].score + " - " + scores[0].score
        : null;
    }
  }
}
